module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }